import React from 'react'
import moment from 'moment'

import Text from 'components/typography/Text/Text'


const Date = ({ color = 'white-80', from, to }) => Boolean(from && to) && (
  <Text
    message={`c ${moment(from).format('DD.MM')} по ${moment(to).format('DD.MM')} `}
    size="12-14"
    color={color}
  />
)


export default Date
